import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { reset } from '../utils/Permissions';
import useAuth  from "../react-jwt-spa";
import {
  TheContent,
  TheSidebar,
  TheAside,
  TheFooter,
  TheHeader
} from './index';

const TheLayout = ({ match }) => {
  const dispatch = useDispatch();  
  const darkMode = useSelector(state => state.darkMode)
  const classes = classNames(
    'c-app c-default-layout',
    darkMode && 'c-dark-theme'
  )
  const { isAuthenticated, isTokenExpired, signOut } = useAuth();
  const anonymousPages = ['#/sign-up', '#/login'];

  var isAnonymousPage = anonymousPages.includes(window.location.hash);

  if ((!isAnonymousPage) && (!isAuthenticated() || isTokenExpired())) {
    signOut();
    window.open(`#/login`, '_self');
  }

  // Reset permissions
  reset(dispatch);

  return (
    <div className={classes}>
      <TheSidebar/>
      <TheAside/>
      <div className="c-wrapper">
        <TheHeader/>
        <div className="c-body">
          <TheContent/>
        </div>
        <TheFooter/>
      </div>
    </div>
  )
}

export default TheLayout
